export default __webpack_public_path__ + "static/media/Communications.15c59ba2.svg";